import { clsx as i } from "../node_modules/clsx/dist/clsx.js";
import { twMerge as r } from "../node_modules/tailwind-merge/dist/bundle-mjs.js";
function f(...e) {
  return r(i(e));
}
function m(e, n) {
  let t = null;
  return function(...u) {
    t || (e(...u), t = setTimeout(() => {
      t = null;
    }, n));
  };
}
function p(e, n) {
  let t = null;
  return function(...u) {
    t && clearTimeout(t), t = setTimeout(() => {
      e(...u), t = null;
    }, n);
  };
}
function a(e) {
  return e.replace(/([A-Z])/g, " $1").trim();
}
export {
  f as cn,
  p as debounce,
  a as pascalToSentence,
  m as throttle
};
